const STORAGE_KEY = 'minecraft_lang';

const LANGUAGE_OPTIONS = [
  { id: 'zh-TW', label: '繁體中文' },
  { id: 'en', label: 'English' }
];

const DICT = {
  'zh-TW': {
    'main.title': '網頁沙盒生存',
    'main.subtitle': '對標 Minecraft 的沙盒生存：採集、戰鬥、建造、合成。',
    'main.control.move': 'W A S D 移動 | 按住 Ctrl 或 R 衝刺 | Shift 蹲下與邊緣保護',
    'main.control.swim': 'Space 跳躍 / 上浮 | Shift 下潛 | 創造模式雙擊 Space 可飛行',
    'main.control.action': '左鍵攻擊 | 按住左鍵挖礦 | 右鍵放置 / 使用',
    'main.control.inventory': 'E 開背包與合成 | 1~9 切換快捷欄',
    'main.start': '開始遊戲',
    'menu.philosophy.open': '創作理念',
    'menu.philosophy.title': 'Buground 創作理念',
    'menu.philosophy.close': '返回',
    'death.title': '你鼠了',
    'death.reason.default.1': '今天的你，和重生點再次成為摯友。',
    'death.reason.default.2': '生命值歸零，靈魂暫時離線中。',
    'death.reason.default.3': '你把生存模式玩成了極限速通。',
    'death.reason.default.4': '系統溫馨提示：活下去似乎比較好玩。',
    'death.reason.default.5': '你用生命證明了這個世界有多危險。',
    'death.reason.mob.1': '你被 {mob} 狠狠上了一堂近戰課。',
    'death.reason.mob.2': '{mob} 表示：這裡不是新手村。',
    'death.reason.mob.3': '{mob} 把你送回重生點補作業。',
    'death.reason.mob.4': '你和 {mob} 談判失敗，判決立即執行。',
    'death.reason.mob.5': '{mob} 覺得你的裝備很好看，可惜現在掉在地上了。',
    'death.reason.fall.1': '你試圖挑戰地心引力，結果地心贏了。',
    'death.reason.fall.2': '你落地很帥，只是血條沒跟上。',
    'death.reason.fall.3': '自由落體結束，人生也短暫重開。',
    'death.reason.fall.4': '牛頓：這就是萬有引力，懂？',
    'death.reason.fall.5': '其實你可以飛的...只是忘記帶翅膀了。',
    'death.reason.void.1': '你下探虛空，虛空也順便收下你。',
    'death.reason.void.2': '你在地圖外散步，然後就沒然後了。',
    'death.reason.void.3': '虛空：歡迎光臨，出口在重生點。',
    'death.reason.void.4': '你達成成就：掉出宇宙邊界。',
    'death.reason.void.5': '這裡什麼都沒有，包括你的生命跡象。',
    'death.reason.starve.1': '你餓到連呼吸都要扣耐久。',
    'death.reason.starve.2': '肚子先下班了，你也跟著下線。',
    'death.reason.starve.3': '你證明了不吃飯真的會出事。',
    'death.reason.starve.4': '身為方塊人，你還是需要卡路里的。',
    'death.reason.starve.5': '美食就在不遠處，可惜你已經走不動了。',
    'death.reason.drown.1': '你和氧氣的合約剛剛到期。',
    'death.reason.drown.2': '水下探索很成功，呼吸管理失敗。',
    'death.reason.drown.3': '你游得很努力，可惜肺不同意。',
    'death.reason.drown.4': '你發現自己並不是兩棲類。',
    'death.reason.drown.5': '喝水是好習慣，但你喝得太多了。',
    'death.reason.lava.1': '你試圖泡岩漿，系統判定太燙。',
    'death.reason.lava.2': '你被高溫說服，立刻回城。',
    'death.reason.lava.3': '岩漿：歡迎，這裡沒有冷卻時間。',
    'death.reason.lava.4': '你體驗了瞬間變成烤肉的感覺。',
    'death.reason.lava.5': '終極溫泉體驗：一次性，不可退款。',
    'death.reason.cactus.1': '你和仙人掌的擁抱方式明顯不同步。',
    'death.reason.cactus.2': '仙人掌提醒你：觀賞可以，貼貼不行。',
    'death.reason.cactus.3': '你把自己送進了全自動扎針流程。',
    'death.reason.bed_explode.1': '你在異世界睡覺，床先爆氣了。',
    'death.reason.bed_explode.2': '床表示：這裡只提供爆炸，不提供睡眠。',
    'death.reason.bed_explode.3': '晚安沒說成，反而說成了 BOOM。',
    'death.reason.bed_explode.4': '看來這張床有起床氣，而且很大。',
    'death.reason.bed_explode.5': '物理法則警告：跨維度睡眠具有致命危險。',
    'death.reason.creeper_explode.1': '苦力怕在你耳邊低語：嘶。',
    'death.reason.creeper_explode.2': '你聽見了「嘶」但反應慢了半拍。',
    'death.reason.creeper_explode.3': '爆炸藝術很成功，你剛好站在正中間。',
    'death.reason.creeper_explode.4': '你收到了一個不請自來的綠色擁抱。',
    'death.reason.creeper_explode.5': '苦力怕：驚不驚喜？意不意外？',
    'menu.rules_title': '遊戲規則',
    'menu.rule.keep_inventory': '死亡不掉落物品',
    'menu.rule.creative_mode': '創造模式',
    'menu.rule.show_coordinates': '顯示座標',
    'menu.rule.show_bgm_panel': '顯示 bgm 面板',
    'menu.options.title': '選項',
    'menu.audio.title': '選項',
    'menu.video.view_distance': '視距',
    'menu.video.texture_style': '材質風格',
    'menu.texture.classic': '原始（程序紋理）',
    'menu.texture.eco': '生態繽紛版（PNG）',
    'menu.texture.industrial': '極簡工業版（PNG）',
    'menu.texture.buji': '不羈風格（PNG）',
    'menu.audio.music': '主音樂',
    'menu.audio.sfx': '音效',
    'menu.seed.title': '世界地圖',
    'menu.seed.label': 'WORLD_SEED',
    'menu.seed.action.apply': '套用並重建地圖',
    'menu.seed.action.random': '隨機 Seed',
    'menu.seed.hint': '改 seed 會立即重載地圖，並切換到該 seed 的存檔槽。',
    'menu.save.title': '存檔',
    'menu.save.action.save': '存檔',
    'menu.save.action.load': '讀檔',
    'menu.save.action.delete': '刪除存檔',
    'menu.save.meta.none': '目前沒有存檔。',
    'menu.save.meta.time': '最近存檔：{time}',
    'hud.day_word': '第 {day} 天',
    'hud.night': '夜晚',
    'hud.day': '白天',
    'hud.health_value': '生命 {value}/{max}',
    'hud.hunger_value': '飽足感 {value}/{max}',
    'hud.armor_value': '護甲 {value}/{max}',
    'hud.xp_value': '等級 {level} 經驗 {current}/{need}',
    'hud.coords_value': '座標 X:{x} Y:{y} Z:{z}',
    'hud.death_recovery_value': '死亡點 X:{x} Y:{y} Z:{z} | 距離 {distance}m',
    'hud.language': '語言',
    'dimension.overworld': '主世界',
    'dimension.nether': '地獄',
    'dimension.end': '終界',

    'objective.header': '生存目標',
    'objective.stage': '任務 {current}/{total}',
    'objective.stage_done': '全部完成',
    'objective.progress': '{value}/{target}',
    'objective.reward_label': '獎勵',
    'objective.all_done': '所有生存目標已完成，開始打造你的世界吧。',
    'objective.toast.complete': '完成目標：{title}',
    'objective.toast.reward': '獲得：{item} x{count}',
    'objective.toast.next': '新目標：{title}',
    'objective.toast.all_done': '你已完成整條目標線，進入自由傳奇模式。',

    'objective.chop_logs.title': '木材供應線',
    'objective.chop_logs.desc': '挖掘原木 {target} 個',
    'objective.place_table.title': '工坊啟動',
    'objective.place_table.desc': '放置工作台 {target} 個',
    'objective.craft_stone_pickaxe.title': '石器升級',
    'objective.craft_stone_pickaxe.desc': '合成石鎬 {target} 把',
    'objective.mine_iron_ore.title': '鐵礦開採',
    'objective.mine_iron_ore.desc': '開採鐵礦石 {target} 個',
    'objective.craft_iron_pickaxe.title': '鐵器時代',
    'objective.craft_iron_pickaxe.desc': '合成鐵鎬 {target} 把',
    'objective.reach_day_two.title': '熬過黑夜',
    'objective.reach_day_two.desc': '生存到第 {day} 天',
    'objective.hunt_hostiles.title': '夜獵清場',
    'objective.hunt_hostiles.desc': '擊殺敵對生物 {target} 隻',
    'objective.collect_diamond.title': '鑽石獵人',
    'objective.collect_diamond.desc': '收集鑽石 {target} 顆',
    'objective.collect_obsidian.title': '黑曜征途',
    'objective.collect_obsidian.desc': '開採黑曜石 {target} 個',

    'ui.inventory_table_title': '工作台合成 (3x3)',
    'ui.inventory_hand_title': '背包合成 (2x2)',
    'ui.table_hint_available': '你在工作台附近，已啟用 3x3 合成。',
    'ui.table_hint_locked': '靠近工作台後可啟用 3x3 合成。',
    'ui.mode_to_2x2': '切換到 2x2',
    'ui.mode_to_3x3': '切換到 3x3',
    'ui.equipment_label': '裝備',
    'ui.inventory_label': '背包',
    'ui.hotbar_label': '快捷欄',
    'ui.trash_label': '垃圾桶',
    'ui.trash_hint': '把游標拿著的物品拖到這裡即可丟棄（右鍵丟 1 個）。',
    'ui.sort_inventory': '整理背包',
    'ui.creative_palette_label': '創造物品欄',
    'ui.creative_palette_hint': '左鍵拿滿堆、右鍵拿 1 個，Shift+左鍵直接放入背包。',
    'ui.creative_search_placeholder': '搜尋道具（中文 / English / ID）',
    'ui.creative_search_empty': '找不到符合的道具。',
    'ui.tip': '左鍵：拿整疊/交換。右鍵：半疊/放一個。空桶可右鍵撈水源/岩漿，裝滿後可右鍵倒出。按住盾牌右鍵格擋；弓按住右鍵蓄力、放開射箭；手持護甲右鍵裝備；對熔爐按右鍵可冶煉；對箱子按右鍵可儲物；對村民按右鍵可交易；對門與地板門按右鍵可開關；手持鋤頭可耕地，骨粉可催熟作物；對床按右鍵可設定重生點（夜晚可睡覺，地獄/終界會爆炸）。Q 可丟出手持物，Ctrl+Q 可丟整疊。Shift+左鍵點結果：連續合成到素材用完。E 或 Esc 關閉。',
    'ui.tip_creative': '創造模式：下方創造物品欄可直接拿所有物品。雙擊 Space 切換飛行，飛行時 Space 上升、Shift 下降。E 或 Esc 關閉。',
    'status.bed_sleep': '你在床上休息後迎來了清晨，重生點已更新。',
    'status.bed_set': '重生點已設為床邊；只能在夜晚睡覺。',
    'status.bed_explode': '{dimension}無法睡床，床發生爆炸！',
    'status.bed_missing': '你的床已無法使用，重生點已回到世界出生點。',
    'status.death_dropped_items': '你死亡時掉落了 {count} 個物品。',
    'status.level_up': '升級！目前等級：{level}',
    'status.portal_activated': '傳送門已啟動，站進去即可傳送。',
    'status.end_portal_activated': '終界門已啟動，站進去即可傳送。',
    'status.portal_travel': '維度躍遷完成：{dimension}',
    'status.ender_dragon_defeated': '終界龍已被擊敗！你征服了終界。',
    'status.rule_keep_inventory_on': '規則已更新：死亡不掉落物品（開啟）',
    'status.rule_keep_inventory_off': '規則已更新：死亡不掉落物品（關閉）',
    'status.rule_creative_on': '已切換為創造模式。',
    'status.rule_creative_off': '已切換為生存模式。',
    'status.rule_coordinates_on': '座標顯示：開啟',
    'status.rule_coordinates_off': '座標顯示：關閉',
    'status.rule_bgm_panel_on': 'bgm 面板：開啟',
    'status.rule_bgm_panel_off': 'bgm 面板：關閉',
    'status.texture_style_switched': '材質風格：{style}',
    'status.save_success': '存檔完成。',
    'status.save_failed': '存檔失敗：儲存空間不足或被瀏覽器阻擋。',
    'status.load_success': '讀檔完成。',
    'status.load_failed': '讀檔失敗：存檔資料格式無效。',
    'status.load_missing': '沒有可讀取的存檔。',
    'status.save_deleted': '已刪除存檔。',
    'status.world_seed_invalid': 'WORLD_SEED 必須是整數。',
    'status.world_seed_save_failed': 'WORLD_SEED 儲存失敗：瀏覽器阻擋了本機儲存。',
    'status.world_seed_unchanged': 'WORLD_SEED 沒有改變。',
    'status.world_seed_saved': '已設定 WORLD_SEED={seed}，正在重載地圖。',
    'status.death_recovery_hint': '死亡掉落 x{count} 已標記在 X:{x} Y:{y} Z:{z}',
    'status.death_recovery_done': '死亡掉落已全部回收。',
    'status.fly_on': '飛行模式：開啟',
    'status.fly_off': '飛行模式：關閉',
    'status.consume_health_full': '生命值已滿，無法使用治療物品。',
    'status.consume_hunger_full': '飽足感已滿，無法進食。',
    'furnace.title': '熔爐',
    'furnace.hint': 'Shift+左鍵可快速在熔爐與背包移動整疊；左鍵整疊存取，右鍵單個存取。',
    'furnace.slot.input': '輸入',
    'furnace.slot.fuel': '燃料',
    'furnace.slot.output': '輸出',
    'furnace.insert_input': '放入輸入',
    'furnace.insert_fuel': '放入燃料',
    'furnace.take_output': '取出輸出',
    'furnace.take_input': '取回輸入',
    'furnace.take_fuel': '取回燃料',
    'furnace.close': '關閉',
    'chest.title': '箱子',
    'chest.hint': 'Shift+左鍵可快速在箱子與背包間移動整疊；左鍵整疊存取，右鍵單個存取。',
    'chest.take_all': '全部取出',
    'chest.close': '關閉',
    'ui.tool.pickaxe': '採礦工具',
    'ui.tool.axe': '伐木工具',
    'ui.tool.shovel': '挖掘工具',
    'ui.tool.hoe': '耕作工具',
    'ui.tool.sword': '近戰武器',
    'ui.tool.bow': '遠程武器',
    'ui.tool.shield': '防禦盾牌',
    'ui.tool.flint_steel': '點火工具',
    'ui.tool.shears': '剪刀採集',
    'ui.tool.bucket': '流體容器',
    'ui.tool.atk': ' 攻擊 {value}',
    'ui.tool.durability': ' 耐久 {value}/{max}',
    'ui.armor.desc': '護甲 +{value} ({slot}){durability}',
    'ui.armor.slot.helmet': '頭盔',
    'ui.armor.slot.chestplate': '胸甲',
    'ui.armor.slot.leggings': '護腿',
    'ui.armor.slot.boots': '靴子',
    'ui.food.desc': '食物 飽足感 +{nutrition}{heal}',
    'ui.food.heal': ' 生命 +{value}',
    'ui.medicine.desc': '醫療 恢復生命 +{heal}',
    'ui.block.desc': '可放置方塊，用於建造與地形改造。',
    'ui.material.desc': '合成素材，可用於配方與進階工具。',
    'ui.item.desc': '一般物品。',

    'item.1': '草地方塊',
    'item.2': '泥土',
    'item.3': '原木',
    'item.4': '樹葉',
    'item.5': '石頭',
    'item.6': '木板',
    'item.8': '鐵礦石',
    'item.10': '鑽石礦石',
    'item.11': '工作台',
    'item.13': '熔爐',
    'item.14': '箱子',
    'item.15': '床',
    'item.16': '木門',
    'item.18': '地板門',
    'item.20': '柵欄',
    'item.21': '砂岩',
    'item.22': '紅磚',
    'item.23': '玻璃',
    'item.24': '白色混凝土',
    'item.25': '柏油路',
    'item.26': '沙子',
    'item.27': '砂礫',
    'item.28': '鵝卵石',
    'item.29': '石磚',
    'item.30': '平滑石',
    'item.31': '黑曜石',
    'item.32': '苔石',
    'item.33': '雕紋石磚',
    'item.34': '裂紋石磚',
    'item.35': '煤炭方塊',
    'item.36': '鐵方塊',
    'item.37': '鑽石方塊',
    'item.38': '螢石',
    'item.39': '石英方塊',
    'item.40': '地獄石',
    'item.41': '靈魂砂',
    'item.42': '地獄磚',
    'item.44': '終界石',
    'item.45': '紫珀方塊',
    'item.47': '金礦石',
    'item.48': '金塊',
    'item.58': '拉桿',
    'item.60': '紅石線',
    'item.62': '紅石燈',
    'item.65': '橡木樹苗',
    'item.66': '莓果叢',
    'item.67': '藍莓叢',
    'item.68': '乾草捆',
    'item.70': '雪塊',
    'item.71': '冰塊',
    'item.72': '仙人掌',
    'item.73': '海帶',
    'item.74': '玄武岩',
    'item.75': '火山岩',
    'item.77': '紅磚方塊',
    'item.78': '樟木原木',
    'item.79': '榕木原木',
    'item.80': '楠木原木',
    'item.81': '樺木原木',
    'item.82': '檜木原木',
    'item.83': '楓木原木',
    'item.84': '針葉木原木',
    'item.85': '柏木原木',
    'item.86': '杉木原木',
    'item.87': '樟木木板',
    'item.88': '榕木木板',
    'item.89': '楠木木板',
    'item.90': '樺木木板',
    'item.91': '檜木木板',
    'item.92': '楓木木板',
    'item.93': '針葉木木板',
    'item.94': '柏木木板',
    'item.95': '杉木木板',
    'item.coal': '煤炭',
    'item.charcoal': '木炭',
    'item.bone': '骨頭',
    'item.bone_meal': '骨粉',
    'item.gunpowder': '火藥',
    'item.feather': '羽毛',
    'item.flint': '燧石',
    'item.ender_eye': '終界之眼',
    'item.flint_steel': '打火石',
    'item.shears': '剪刀',
    'item.bucket': '鐵桶',
    'item.water_bucket': '水桶',
    'item.lava_bucket': '岩漿桶',
    'item.boat': '木船',
    'item.bamboo_raft': '竹筏',
    'item.leather': '皮革',
    'item.wool': '羊毛',
    'item.rotten_flesh': '腐肉',
    'item.spider_eye': '蜘蛛眼',
    'item.stick': '木棍',
    'item.string': '線',
    'item.arrow': '箭',
    'item.iron_ingot': '鐵錠',
    'item.gold_ingot': '金錠',
    'item.diamond_gem': '鑽石',
    'item.emerald': '綠寶石',
    'item.wheat_seed': '小麥種子',
    'item.wheat': '小麥',
    'item.berry': '莓果',
    'item.blueberry': '藍莓',
    'item.aloe': '蘆薈',
    'item.painkiller': '止痛藥',
    'item.medkit': '醫療補包',
    'item.torch': '火把',
    'item.beef_raw': '生牛肉',
    'item.mutton_raw': '生羊肉',
    'item.pork_raw': '生豬肉',
    'item.chicken_raw': '生雞肉',
    'item.beef_cooked': '牛排',
    'item.mutton_cooked': '熟羊肉',
    'item.pork_cooked': '熟豬肉',
    'item.chicken_cooked': '熟雞肉',
    'item.bread': '麵包',
    'item.apple': '蘋果',
    'item.wood_pickaxe': '木鎬',
    'item.stone_pickaxe': '石鎬',
    'item.iron_pickaxe': '鐵鎬',
    'item.diamond_pickaxe': '鑽石鎬',
    'item.wood_axe': '木斧',
    'item.stone_axe': '石斧',
    'item.iron_axe': '鐵斧',
    'item.diamond_axe': '鑽石斧',
    'item.wood_shovel': '木鏟',
    'item.stone_shovel': '石鏟',
    'item.iron_shovel': '鐵鏟',
    'item.diamond_shovel': '鑽石鏟',
    'item.wood_hoe': '木鋤',
    'item.stone_hoe': '石鋤',
    'item.iron_hoe': '鐵鋤',
    'item.diamond_hoe': '鑽石鋤',
    'item.wood_sword': '木劍',
    'item.stone_sword': '石劍',
    'item.iron_sword': '鐵劍',
    'item.diamond_sword': '鑽石劍',
    'item.gold_pickaxe': '金鎬',
    'item.gold_axe': '金斧',
    'item.gold_shovel': '金鏟',
    'item.gold_hoe': '金鋤',
    'item.gold_sword': '金劍',
    'item.bow': '弓',
    'item.shield': '盾牌',
    'item.leather_helmet': '皮帽',
    'item.leather_chestplate': '皮外套',
    'item.leather_leggings': '皮褲',
    'item.leather_boots': '皮靴',
    'item.iron_helmet': '鐵頭盔',
    'item.iron_chestplate': '鐵胸甲',
    'item.iron_leggings': '鐵護腿',
    'item.iron_boots': '鐵靴子',
    'item.diamond_helmet': '鑽石頭盔',
    'item.diamond_chestplate': '鑽石胸甲',
    'item.diamond_leggings': '鑽石護腿',
    'item.diamond_boots': '鑽石靴子',
    'item.gold_helmet': '金頭盔',
    'item.gold_chestplate': '金胸甲',
    'item.gold_leggings': '金護腿',
    'item.gold_boots': '金靴子',
    'villager.default_name': '村民',
    'villager.trade.title': '村民交易',
    'villager.trade.hint': '點選交易按鈕即可兌換。交易次數用完後會暫時售罄。',
    'villager.trade.close': '關閉',
    'villager.trade.profile': '{name}（{profession}）',
    'villager.trade.uses': '已交易 {current}/{max}',
    'villager.trade.buy': '交易',
    'villager.trade.sold_out': '售罄',
    'villager.trade.cannot_afford': '材料不足，無法交易。',
    'villager.trade.inventory_full': '背包空間不足。',
    'villager.trade.success': '交易成功：{item} x{count}',
    'villager.trade.restocked': '村民已補貨，可再次交易。',
    'villager.profession.farmer': '農夫',
    'villager.profession.fletcher': '製箭師',
    'villager.profession.blacksmith': '鐵匠',
    'villager.profession.armorer': '盔甲匠',
    'villager.profession.cleric': '牧師',
    'villager.profession.butcher': '屠夫',
    'mob.villager_with_profession': '{profession}村民',
    'mob.zombie': '殭屍',
    'mob.skeleton': '骷髏',
    'mob.skeleton_archer': '骷髏弓箭手',
    'mob.creeper': '苦力怕',
    'mob.spider': '蜘蛛',
    'mob.enderman': '終界使者',
    'mob.husk': '屍殼',
    'mob.stray': '流髑',
    'mob.pillager': '掠奪者',
    'mob.raider_brute': '掠襲蠻兵',
    'mob.drowned': '沉屍',
    'mob.ender_dragon': '終界龍',
    'mob.villager': '村民',
    'mob.cow': '牛',
    'mob.sheep': '綿羊',
    'mob.pig': '豬',
    'mob.chicken': '雞',
    'mob.goat': '山羊',
    'mob.wild_boar': '野豬',
    'mob.duck': '鴨子'
  },
  en: {
    'main.title': 'Web Voxel Survival',
    'main.subtitle': 'Minecraft-style sandbox survival: gather, fight, build, and craft.',
    'main.control.move': 'W A S D Move | Hold Ctrl or R to Sprint | Shift Crouch + edge safety',
    'main.control.swim': 'Space Jump / Swim up | Shift Swim down | Double-tap Space in Creative to fly',
    'main.control.action': 'Left Click Attack | Hold Left Click Mine | Right Click Place / Use',
    'main.control.inventory': 'E Inventory + Crafting | 1~9 Switch hotbar slot',
    'main.start': 'Start Game',
    'menu.philosophy.open': 'Design Philosophy',
    'menu.philosophy.title': 'Buground Design Philosophy',
    'menu.philosophy.close': 'Back',
    'death.title': 'You Died',
    'death.reason.default.1': 'You and the respawn point are close friends now.',
    'death.reason.default.2': 'HP hit zero. Spirit reboot in progress.',
    'death.reason.default.3': 'That was an unplanned any% speedrun.',
    'death.reason.default.4': 'System hint: surviving is generally more fun.',
    'death.reason.default.5': 'You successfully proved how dangerous this world is.',
    'death.reason.mob.1': '{mob} just taught a very practical combat lesson.',
    'death.reason.mob.2': '{mob} says this is not a tutorial zone.',
    'death.reason.mob.3': '{mob} escorted you back to spawn.',
    'death.reason.mob.4': 'Negotiation with {mob} has failed successfully.',
    'death.reason.mob.5': '{mob} liked your gear, unfortunately it is now dropped on the floor.',
    'death.reason.fall.1': 'Gravity won that argument.',
    'death.reason.fall.2': 'Great landing pose, unfortunate HP outcome.',
    'death.reason.fall.3': 'Freefall complete. Life paused.',
    'death.reason.fall.4': 'Newton says hi. That was gravity.',
    'death.reason.fall.5': 'You could fly... you just forgot your wings.',
    'death.reason.void.1': 'You explored the void. The void explored back.',
    'death.reason.void.2': 'Out-of-bounds tourism ended abruptly.',
    'death.reason.void.3': 'The void says hello. Spawn says welcome back.',
    'death.reason.void.4': 'Achievement Unlocked: Fell out of the universe.',
    'death.reason.void.5': 'There is nothing here, including your vitals.',
    'death.reason.starve.1': 'Hunger reached critical. Survival did not.',
    'death.reason.starve.2': 'Your stomach rage-quit first.',
    'death.reason.starve.3': 'Skipping meals has consequences.',
    'death.reason.starve.4': 'As a block person, you still need calories.',
    'death.reason.starve.5': 'Food was nearby, but you lacked the energy to reach it.',
    'death.reason.drown.1': 'Your oxygen subscription just expired.',
    'death.reason.drown.2': 'Excellent dive, poor breathing plan.',
    'death.reason.drown.3': 'Swimming skill: yes. Breathing skill: no.',
    'death.reason.drown.4': 'You discovered you are not amphibian.',
    'death.reason.drown.5': 'Hydration is good, but you drank too much.',
    'death.reason.lava.1': 'Lava bath detected. Temperature not approved.',
    'death.reason.lava.2': 'You were outvoted by molten rock.',
    'death.reason.lava.3': 'Welcome to lava. Cooling not included.',
    'death.reason.lava.4': 'You experienced an instant barbecue.',
    'death.reason.lava.5': 'Ultimate hot spring experience: strictly non-refundable.',
    'death.reason.cactus.1': 'You and the cactus disagreed on what counts as a hug.',
    'death.reason.cactus.2': 'The cactus would like to remind you: look, do not cuddle.',
    'death.reason.cactus.3': 'You volunteered for an automated needle test.',
    'death.reason.bed_explode.1': 'You tried to sleep in the wrong dimension.',
    'death.reason.bed_explode.2': 'Bed service unavailable. Explosion service enabled.',
    'death.reason.bed_explode.3': 'You said good night. The bed said BOOM.',
    'death.reason.bed_explode.4': 'Looks like the bed woke up on the wrong side.',
    'death.reason.bed_explode.5': 'Physics warning: interdimensional sleep is fatal.',
    'death.reason.creeper_explode.1': 'Creeper whispered "sssss" and meant business.',
    'death.reason.creeper_explode.2': 'You heard the hiss, just one beat too late.',
    'death.reason.creeper_explode.3': 'Impressive blast. You were center stage.',
    'death.reason.creeper_explode.4': 'You received an unsolicited green hug.',
    'death.reason.creeper_explode.5': 'Creeper asks: surprise?',
    'menu.rules_title': 'Game Rules',
    'menu.rule.keep_inventory': 'Keep Inventory On Death',
    'menu.rule.creative_mode': 'Creative Mode',
    'menu.rule.show_coordinates': 'Show Coordinates',
    'menu.rule.show_bgm_panel': 'Show BGM Panel',
    'menu.audio.title': 'Options',
    'menu.video.view_distance': 'View Distance',
    'menu.video.texture_style': 'Texture Style',
    'menu.texture.classic': 'Classic (Procedural)',
    'menu.texture.eco': 'Eco Vivid (PNG)',
    'menu.texture.industrial': 'Minimal Industrial (PNG)',
    'menu.texture.buji': 'Buji Style (PNG)',
    'menu.audio.music': 'Music',
    'menu.audio.sfx': 'SFX',
    'menu.seed.title': 'World Map',
    'menu.seed.label': 'WORLD_SEED',
    'menu.seed.action.apply': 'Apply & Reload Map',
    'menu.seed.action.random': 'Random Seed',
    'menu.seed.hint': 'Changing seed reloads the map immediately and switches save slots by seed.',
    'menu.save.title': 'Save',
    'menu.save.action.save': 'Save',
    'menu.save.action.load': 'Load',
    'menu.save.action.delete': 'Delete Save',
    'menu.save.meta.none': 'No save data yet.',
    'menu.save.meta.time': 'Last save: {time}',
    'hud.day_word': 'Day {day}',
    'hud.night': 'Night',
    'hud.day': 'Daytime',
    'hud.health_value': 'Health {value}/{max}',
    'hud.hunger_value': 'Satiety {value}/{max}',
    'hud.armor_value': 'Armor {value}/{max}',
    'hud.xp_value': 'Level {level} XP {current}/{need}',
    'hud.coords_value': 'XYZ {x} / {y} / {z}',
    'hud.death_recovery_value': 'Death Cache X:{x} Y:{y} Z:{z} | Dist {distance}m',
    'hud.language': 'Language',
    'dimension.overworld': 'Overworld',
    'dimension.nether': 'Nether',
    'dimension.end': 'The End',

    'objective.header': 'Survival Goals',
    'objective.stage': 'Mission {current}/{total}',
    'objective.stage_done': 'All Clear',
    'objective.progress': '{value}/{target}',
    'objective.reward_label': 'Reward',
    'objective.all_done': 'All survival goals completed. Build your own legend now.',
    'objective.toast.complete': 'Goal complete: {title}',
    'objective.toast.reward': 'Gained: {item} x{count}',
    'objective.toast.next': 'New goal: {title}',
    'objective.toast.all_done': 'Goal chain complete. Free legend mode unlocked.',

    'objective.chop_logs.title': 'Wood Supply Run',
    'objective.chop_logs.desc': 'Mine {target} logs',
    'objective.place_table.title': 'Workshop Online',
    'objective.place_table.desc': 'Place {target} crafting table',
    'objective.craft_stone_pickaxe.title': 'Stone Upgrade',
    'objective.craft_stone_pickaxe.desc': 'Craft {target} stone pickaxe',
    'objective.mine_iron_ore.title': 'Iron Rush',
    'objective.mine_iron_ore.desc': 'Mine {target} iron ore blocks',
    'objective.craft_iron_pickaxe.title': 'Iron Age',
    'objective.craft_iron_pickaxe.desc': 'Craft {target} iron pickaxe',
    'objective.reach_day_two.title': 'Survive The Night',
    'objective.reach_day_two.desc': 'Reach Day {day}',
    'objective.hunt_hostiles.title': 'Hostile Cleanup',
    'objective.hunt_hostiles.desc': 'Defeat {target} hostile mobs',
    'objective.collect_diamond.title': 'Diamond Hunter',
    'objective.collect_diamond.desc': 'Collect {target} diamonds',
    'objective.collect_obsidian.title': 'Obsidian Quest',
    'objective.collect_obsidian.desc': 'Mine {target} obsidian blocks',

    'ui.inventory_table_title': 'Crafting Table (3x3)',
    'ui.inventory_hand_title': 'Inventory Crafting (2x2)',
    'ui.table_hint_available': 'You are near a crafting table. 3x3 crafting is enabled.',
    'ui.table_hint_locked': 'Move near a crafting table to enable 3x3 crafting.',
    'ui.mode_to_2x2': 'Switch to 2x2',
    'ui.mode_to_3x3': 'Switch to 3x3',
    'ui.equipment_label': 'Equipment',
    'ui.inventory_label': 'Inventory',
    'ui.hotbar_label': 'Hotbar',
    'ui.trash_label': 'Trash',
    'ui.trash_hint': 'Drag the cursor stack here to destroy it (right click destroys one).',
    'ui.sort_inventory': 'Sort Inventory',
    'ui.creative_palette_label': 'Creative Items',
    'ui.creative_palette_hint': 'Left click for full stack, right click for one, Shift+Left click to insert into inventory.',
    'ui.creative_search_placeholder': 'Search items (Chinese / English / ID)',
    'ui.creative_search_empty': 'No matching items found.',
    'ui.tip': 'Left click: take/swap stacks. Right click: split/place one. Empty buckets can scoop water sources or lava, and filled buckets can pour fluids. Hold right click with shield to block; hold right click with bow to charge and release to shoot; hold armor + right click to equip; right click a furnace to smelt; right click a chest to store items; right click a villager to trade; right click doors/trapdoors to toggle; use hoes to till soil and bone meal to grow crops faster; right click a bed to set spawn (sleep at night, but beds explode in Nether/End). Q drops held item, Ctrl+Q drops a full stack. Shift+Left click result: craft repeatedly until materials run out. E or Esc to close.',
    'ui.tip_creative': 'Creative mode: use the creative item palette below to take any item. Double-tap Space to toggle flight; while flying, Space ascends and Shift descends. E or Esc to close.',
    'status.bed_sleep': 'You slept through the night. Spawn point updated.',
    'status.bed_set': 'Spawn point set to this bed. You can only sleep at night.',
    'status.bed_explode': 'Beds explode in {dimension}.',
    'status.bed_missing': 'Your bed is unavailable. Respawn moved back to world spawn.',
    'status.death_dropped_items': 'You dropped {count} items on death.',
    'status.level_up': 'Level up! Current level: {level}',
    'status.portal_activated': 'Portal activated. Step in to travel.',
    'status.end_portal_activated': 'End portal activated. Step in to travel.',
    'status.portal_travel': 'Dimension shift complete: {dimension}',
    'status.ender_dragon_defeated': 'Ender Dragon defeated! The End is yours.',
    'status.rule_keep_inventory_on': 'Rule updated: keep inventory on death (ON).',
    'status.rule_keep_inventory_off': 'Rule updated: keep inventory on death (OFF).',
    'status.rule_creative_on': 'Switched to Creative Mode.',
    'status.rule_creative_off': 'Switched to Survival Mode.',
    'status.rule_coordinates_on': 'Coordinates display: ON.',
    'status.rule_coordinates_off': 'Coordinates display: OFF.',
    'status.rule_bgm_panel_on': 'BGM panel: ON.',
    'status.rule_bgm_panel_off': 'BGM panel: OFF.',
    'status.texture_style_switched': 'Texture style: {style}',
    'status.save_success': 'Game saved.',
    'status.save_failed': 'Save failed: storage unavailable or quota exceeded.',
    'status.load_success': 'Game loaded.',
    'status.load_failed': 'Load failed: save data is invalid.',
    'status.load_missing': 'No save file found.',
    'status.save_deleted': 'Save deleted.',
    'status.world_seed_invalid': 'WORLD_SEED must be an integer.',
    'status.world_seed_save_failed': 'Failed to save WORLD_SEED: local storage is blocked.',
    'status.world_seed_unchanged': 'WORLD_SEED is unchanged.',
    'status.world_seed_saved': 'WORLD_SEED={seed} applied. Reloading map.',
    'status.death_recovery_hint': 'Death cache x{count} marked at X:{x} Y:{y} Z:{z}',
    'status.death_recovery_done': 'All death cache items recovered.',
    'status.fly_on': 'Flight mode: ON',
    'status.fly_off': 'Flight mode: OFF',
    'status.consume_health_full': 'Health is full. Cannot use healing items.',
    'status.consume_hunger_full': 'Satiety is full. Cannot eat food.',
    'furnace.title': 'Furnace',
    'furnace.hint': 'Shift+left click quick-moves stacks between furnace and inventory. Left click moves full stacks, right click moves one.',
    'furnace.slot.input': 'Input',
    'furnace.slot.fuel': 'Fuel',
    'furnace.slot.output': 'Output',
    'furnace.insert_input': 'Insert Input',
    'furnace.insert_fuel': 'Insert Fuel',
    'furnace.take_output': 'Take Output',
    'furnace.take_input': 'Take Input',
    'furnace.take_fuel': 'Take Fuel',
    'furnace.close': 'Close',
    'chest.title': 'Chest',
    'chest.hint': 'Shift+left click quick-moves full stacks between chest and inventory. Left click moves full stacks, right click moves one.',
    'chest.take_all': 'Take All',
    'chest.close': 'Close',
    'ui.tool.pickaxe': 'Mining Tool',
    'ui.tool.axe': 'Wood Tool',
    'ui.tool.shovel': 'Digging Tool',
    'ui.tool.hoe': 'Farming Tool',
    'ui.tool.sword': 'Melee Weapon',
    'ui.tool.bow': 'Ranged Weapon',
    'ui.tool.shield': 'Defensive Shield',
    'ui.tool.flint_steel': 'Ignition Tool',
    'ui.tool.shears': 'Harvest Shears',
    'ui.tool.bucket': 'Fluid Container',
    'ui.tool.atk': ' ATK {value}',
    'ui.tool.durability': ' Durability {value}/{max}',
    'ui.armor.desc': 'Armor +{value} ({slot}){durability}',
    'ui.armor.slot.helmet': 'Helmet',
    'ui.armor.slot.chestplate': 'Chestplate',
    'ui.armor.slot.leggings': 'Leggings',
    'ui.armor.slot.boots': 'Boots',
    'ui.food.desc': 'Food Satiety +{nutrition}{heal}',
    'ui.food.heal': ' Heal +{value}',
    'ui.medicine.desc': 'Medicine Heal +{heal}',
    'ui.block.desc': 'Placeable block for building and terrain shaping.',
    'ui.material.desc': 'Crafting material for recipes and progression.',
    'ui.item.desc': 'General item.',

    'item.1': 'Grass Block',
    'item.2': 'Dirt',
    'item.3': 'Log',
    'item.4': 'Leaves',
    'item.5': 'Stone',
    'item.6': 'Planks',
    'item.8': 'Iron Ore',
    'item.10': 'Diamond Ore',
    'item.11': 'Crafting Table',
    'item.13': 'Furnace',
    'item.14': 'Chest',
    'item.15': 'Bed',
    'item.16': 'Oak Door',
    'item.18': 'Trapdoor',
    'item.20': 'Fence',
    'item.21': 'Sandstone',
    'item.22': 'Bricks',
    'item.23': 'Glass',
    'item.24': 'White Concrete',
    'item.25': 'Asphalt',
    'item.26': 'Sand',
    'item.27': 'Gravel',
    'item.28': 'Cobblestone',
    'item.29': 'Stone Bricks',
    'item.30': 'Smooth Stone',
    'item.31': 'Obsidian',
    'item.32': 'Mossy Cobblestone',
    'item.33': 'Chiseled Stone Bricks',
    'item.34': 'Cracked Stone Bricks',
    'item.35': 'Block of Coal',
    'item.36': 'Block of Iron',
    'item.37': 'Block of Diamond',
    'item.38': 'Glowstone',
    'item.39': 'Quartz Block',
    'item.40': 'Netherrack',
    'item.41': 'Soul Sand',
    'item.42': 'Nether Bricks',
    'item.44': 'End Stone',
    'item.45': 'Purpur Block',
    'item.47': 'Gold Ore',
    'item.48': 'Block of Gold',
    'item.58': 'Lever',
    'item.60': 'Redstone Wire',
    'item.62': 'Redstone Lamp',
    'item.65': 'Oak Sapling',
    'item.66': 'Berry Bush',
    'item.67': 'Blueberry Bush',
    'item.68': 'Hay Bale',
    'item.70': 'Snow Block',
    'item.71': 'Ice',
    'item.72': 'Cactus',
    'item.73': 'Kelp',
    'item.74': 'Basalt',
    'item.75': 'Volcanic Rock',
    'item.77': 'Red Brick',
    'item.78': 'Camphor Log',
    'item.79': 'Banyan Log',
    'item.80': 'Nanmu Log',
    'item.81': 'Birch Log',
    'item.82': 'Cypress Log',
    'item.83': 'Maple Log',
    'item.84': 'Conifer Log',
    'item.85': 'Juniper Log',
    'item.86': 'Fir Log',
    'item.87': 'Camphor Planks',
    'item.88': 'Banyan Planks',
    'item.89': 'Nanmu Planks',
    'item.90': 'Birch Planks',
    'item.91': 'Cypress Planks',
    'item.92': 'Maple Planks',
    'item.93': 'Conifer Planks',
    'item.94': 'Juniper Planks',
    'item.95': 'Fir Planks',
    'item.coal': 'Coal',
    'item.charcoal': 'Charcoal',
    'item.bone': 'Bone',
    'item.bone_meal': 'Bone Meal',
    'item.gunpowder': 'Gunpowder',
    'item.feather': 'Feather',
    'item.flint': 'Flint',
    'item.ender_eye': 'Eye of Ender',
    'item.flint_steel': 'Flint and Steel',
    'item.shears': 'Shears',
    'item.bucket': 'Bucket',
    'item.water_bucket': 'Water Bucket',
    'item.lava_bucket': 'Lava Bucket',
    'item.boat': 'Boat',
    'item.bamboo_raft': 'Bamboo Raft',
    'item.leather': 'Leather',
    'item.wool': 'Wool',
    'item.rotten_flesh': 'Rotten Flesh',
    'item.spider_eye': 'Spider Eye',
    'item.stick': 'Stick',
    'item.string': 'String',
    'item.arrow': 'Arrow',
    'item.iron_ingot': 'Iron Ingot',
    'item.gold_ingot': 'Gold Ingot',
    'item.diamond_gem': 'Diamond',
    'item.emerald': 'Emerald',
    'item.wheat_seed': 'Wheat Seeds',
    'item.wheat': 'Wheat',
    'item.berry': 'Berry',
    'item.blueberry': 'Blueberry',
    'item.aloe': 'Aloe',
    'item.painkiller': 'Painkiller',
    'item.medkit': 'Med Kit',
    'item.torch': 'Torch',
    'item.beef_raw': 'Raw Beef',
    'item.mutton_raw': 'Raw Mutton',
    'item.pork_raw': 'Raw Pork',
    'item.chicken_raw': 'Raw Chicken',
    'item.beef_cooked': 'Steak',
    'item.mutton_cooked': 'Cooked Mutton',
    'item.pork_cooked': 'Cooked Porkchop',
    'item.chicken_cooked': 'Cooked Chicken',
    'item.bread': 'Bread',
    'item.apple': 'Apple',
    'item.wood_pickaxe': 'Wood Pickaxe',
    'item.stone_pickaxe': 'Stone Pickaxe',
    'item.iron_pickaxe': 'Iron Pickaxe',
    'item.diamond_pickaxe': 'Diamond Pickaxe',
    'item.wood_axe': 'Wood Axe',
    'item.stone_axe': 'Stone Axe',
    'item.iron_axe': 'Iron Axe',
    'item.diamond_axe': 'Diamond Axe',
    'item.wood_shovel': 'Wood Shovel',
    'item.stone_shovel': 'Stone Shovel',
    'item.iron_shovel': 'Iron Shovel',
    'item.diamond_shovel': 'Diamond Shovel',
    'item.wood_hoe': 'Wood Hoe',
    'item.stone_hoe': 'Stone Hoe',
    'item.iron_hoe': 'Iron Hoe',
    'item.diamond_hoe': 'Diamond Hoe',
    'item.wood_sword': 'Wood Sword',
    'item.stone_sword': 'Stone Sword',
    'item.iron_sword': 'Iron Sword',
    'item.diamond_sword': 'Diamond Sword',
    'item.gold_pickaxe': 'Gold Pickaxe',
    'item.gold_axe': 'Gold Axe',
    'item.gold_shovel': 'Gold Shovel',
    'item.gold_hoe': 'Gold Hoe',
    'item.gold_sword': 'Gold Sword',
    'item.bow': 'Bow',
    'item.shield': 'Shield',
    'item.leather_helmet': 'Leather Cap',
    'item.leather_chestplate': 'Leather Tunic',
    'item.leather_leggings': 'Leather Pants',
    'item.leather_boots': 'Leather Boots',
    'item.iron_helmet': 'Iron Helmet',
    'item.iron_chestplate': 'Iron Chestplate',
    'item.iron_leggings': 'Iron Leggings',
    'item.iron_boots': 'Iron Boots',
    'item.diamond_helmet': 'Diamond Helmet',
    'item.diamond_chestplate': 'Diamond Chestplate',
    'item.diamond_leggings': 'Diamond Leggings',
    'item.diamond_boots': 'Diamond Boots',
    'item.gold_helmet': 'Gold Helmet',
    'item.gold_chestplate': 'Gold Chestplate',
    'item.gold_leggings': 'Gold Leggings',
    'item.gold_boots': 'Gold Boots',
    'villager.default_name': 'Villager',
    'villager.trade.title': 'Villager Trading',
    'villager.trade.hint': 'Click a trade button to exchange items. Offers lock when uses are exhausted.',
    'villager.trade.close': 'Close',
    'villager.trade.profile': '{name} ({profession})',
    'villager.trade.uses': 'Traded {current}/{max}',
    'villager.trade.buy': 'Trade',
    'villager.trade.sold_out': 'Sold Out',
    'villager.trade.cannot_afford': 'Not enough items for this trade.',
    'villager.trade.inventory_full': 'Inventory is full.',
    'villager.trade.success': 'Trade complete: {item} x{count}',
    'villager.trade.restocked': 'Villager offers have been restocked.',
    'villager.profession.farmer': 'Farmer',
    'villager.profession.fletcher': 'Fletcher',
    'villager.profession.blacksmith': 'Blacksmith',
    'villager.profession.armorer': 'Armorer',
    'villager.profession.cleric': 'Cleric',
    'villager.profession.butcher': 'Butcher',
    'mob.villager_with_profession': '{profession} Villager',
    'mob.zombie': 'Zombie',
    'mob.skeleton': 'Skeleton',
    'mob.skeleton_archer': 'Skeleton Archer',
    'mob.creeper': 'Creeper',
    'mob.spider': 'Spider',
    'mob.enderman': 'Enderman',
    'mob.husk': 'Husk',
    'mob.stray': 'Stray',
    'mob.pillager': 'Pillager',
    'mob.raider_brute': 'Raider Brute',
    'mob.drowned': 'Drowned',
    'mob.ender_dragon': 'Ender Dragon',
    'mob.villager': 'Villager',
    'mob.cow': 'Cow',
    'mob.sheep': 'Sheep',
    'mob.pig': 'Pig',
    'mob.chicken': 'Chicken',
    'mob.goat': 'Goat',
    'mob.wild_boar': 'Wild Boar',
    'mob.duck': 'Duck'
  }
};

let currentLang = 'zh-TW';
try {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && DICT[saved]) currentLang = saved;
} catch {}

const listeners = new Set();

export function getLanguageOptions() {
  return LANGUAGE_OPTIONS.slice();
}

export function getLanguage() {
  return currentLang;
}

export function setLanguage(lang) {
  if (!DICT[lang] || lang === currentLang) return;
  currentLang = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {}
  for (const fn of listeners) fn(currentLang);
}

export function onLanguageChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function tForLang(lang, key, vars = {}) {
  const dict = DICT[lang] || DICT.en;
  let text = dict[key] || DICT.en[key] || key;
  for (const [k, v] of Object.entries(vars)) {
    text = text.replaceAll(`{${k}}`, String(v));
  }
  return text;
}

export function t(key, vars = {}) {
  return tForLang(currentLang, key, vars);
}
